import { render } from "./HeroiconsOutlineSearch.vue?vue&type=template&id=28762b55"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSearch.vue"]])

export default __exports__